import { createContext, useContext } from "react";
import { PageType } from "types/graphql-types";

export const PageTypeContext = createContext<PageType>("PAGE");

export function usePageType(): PageType {
  return useContext(PageTypeContext);
}
